import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import Navbar from '../components/Navbar';
import BookingSystem from '../components/BookingSystem';
import Footer from '../components/Footer';
import AdminModal from '../components/AdminModal';
import LanguageSelector from '../components/LanguageSelector';
import { translations } from '../data/translations';

const BookingPage = () => {
  const [language, setLanguage] = useState('en');
  const [showAdminModal, setShowAdminModal] = useState(false);
  const navigate = useNavigate();
  
  const t = translations[language];

  useEffect(() => {
    document.title = `Book Appointment - Physio Sphere | ${t.hero?.name || 'Pritish Nanda Pradhan'}`;
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 
        `Book your physiotherapy appointment online with ${t.hero?.name || 'Pritish Nanda Pradhan'}. Professional treatment for orthopedic, neurological, and sports injuries in Sambalpur, Odisha.`
      );
    }

    return () => {
      document.title = 'Physio Sphere - Professional Physiotherapy Services | Pritish Nanda Pradhan';
      if (metaDescription) {
        metaDescription.setAttribute('content', 
          'Professional Physiotherapy Services by Pritish Nanda Pradhan - BPT. Expert treatment for orthopedic, neurological, and sports injuries. Book your appointment online.'
        );
      }
    };
  }, [t.hero?.name]);

  const scrollToSection = (sectionId) => {
    if (sectionId === 'home') {
      navigate('/');
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  const handleAdminLogin = (password) => {
    if (password === 'kanaihyaSpeedy') {
      navigate('/admin');
      return true;
    }
    return false;
  };

  return (
    <div className="App">
        <Navbar 
          t={t} 
          activeSection="booking"
          scrollToSection={scrollToSection}
        />
        
        <main>
          <section className="booking-content-section">
             <Container>
            <Row className="mb-4">
              <Col>
                <button 
                  onClick={() => navigate('/')}
                  className="back-to-home-btn d-flex align-items-center gap-2 border-0"
                >
                  <FaArrowLeft /> {t.navigation?.backToHome || 'Back to Home'}
                </button>
              </Col>
            </Row>
          </Container>
            <Container>
              <Row className="justify-content-center">
                <Col lg={10} xl={8}>
                  <BookingSystem t={t} />
                </Col>
              </Row>
            </Container>
          </section>
        </main>
        
        {/* Language Selector */}
        <LanguageSelector 
          language={language} 
          setLanguage={setLanguage} 
        />
        
        <Footer 
          t={t} 
          scrollToSection={scrollToSection}
          onAdminClick={() => setShowAdminModal(true)}
        />
        
        <AdminModal
          show={showAdminModal}
          onHide={() => setShowAdminModal(false)}
          onLogin={handleAdminLogin}
          t={t}
        />
      </div>
    );
};

export default BookingPage;